import * as helper from "@/common/helper";
import regionsFile from "@/static-texts/regions.json";

import listsFile from "@/static-texts/lists.json";

const { citta, regioni } = regionsFile;
const { settori } = listsFile;
const FIRST_CHARACTER = 0;

export const Status = {
  ACTIVATING: "In Attivazione",
  OPEN: "Aperto",
  REPORTING: "In rendicontazione",
  CLOSED: "Chiuso",
};

export function getStatusValue(status, isPreview) {
  if (!status && !isPreview) {
    return -2;
  }
  if (isPreview) {
    return -1;
  }
  const map = [
    { name: Status.ACTIVATING, value: 0 },
    { name: Status.OPEN, value: 1 },
    { name: Status.REPORTING, value: 2 },
    { name: Status.CLOSED, value: 3 },
  ];

  const value = map.find(({ name }) => name === status)?.value;
  return value;
}

export function sortAnnouncementByStatus(announcements) {
  const sortedAnnoucement = announcements ? [...announcements] : [];
  sortedAnnoucement.sort((item1, item2) => {
    const status1 = getStatus({ announcement: item1 });
    const status2 = getStatus({ announcement: item2 });
    if (
      getStatusValue(status1, item1.isPreview) <
      getStatusValue(status2, item2.isPreview)
    )
      return -1;
    if (
      getStatusValue(status1, item1.isPreview) >
      getStatusValue(status2, item2.isPreview)
    )
      return 1;
    else return 0;
  });
  return sortedAnnoucement;
}

export function getCorrelatedServices({ announcement, services }) {
  const list = [];
  if (!announcement) return list;
  const { correlatedServices } = announcement;
  correlatedServices.forEach((id) => {
    const serviceTarget = services.find((serv) => {
      return serv.id === id;
    });
    if (serviceTarget) {
      list.push(serviceTarget);
    }
  });
  return list;
}

export function getCorrelatedAnnouncements({ announcement, announcements }) {
  const list = [];
  if (!announcement) return list;
  const { correlatedAnnouncements } = announcement;

  correlatedAnnouncements.forEach((id) => {
    const announcementTarget = announcements?.find((ann) => {
      return ann.id === id;
    });
    const now = Date.now();

    if (
      announcementTarget &&
      announcementTarget.closingDate &&
      now < announcementTarget?.closingDate
    ) {
      list.push(announcementTarget);
    }
  });
  return list;
}

export const PLACEHOLDER = "/images/services/placeholder.jpg";
export const PROPERTY_PLACEHOLDER = "Non disponibile";

const IMAGE_COMBINATIONS = {
  1: { min: 1, max: 6 },
  2: { min: 1, max: 2 },
  3: { min: 1, max: 2 },
  4: { min: 1, max: 2 },
  5: { min: 1, max: 3 },
  6: { min: 1, max: 1 },
  7: { min: 1, max: 2 },
  8: { min: 1, max: 2 },
  9: { min: 1, max: 3 },
  10: { min: 1, max: 2 },
  11: { min: 1, max: 2 },
  12: { min: 1, max: 1 },
  13: { min: 1, max: 2 },
  14: { min: 1, max: 2 },
  15: { min: 1, max: 1 },
  16: { min: 1, max: 3 },
  17: { min: 1, max: 2 },
  18: { min: 1, max: 2 },
  19: { min: 1, max: 5 },
  20: { min: 1, max: 1 },
  21: { min: 1, max: 1 },
  22: { min: 1, max: 2 },
  23: { min: 1, max: 3 },
  24: { min: 1, max: 1 },
  25: { min: 1, max: 2 },
  26: { min: 1, max: 1 },
  27: { min: 1, max: 2 },
  28: { min: 1, max: 1 },
  29: { min: 1, max: 2 },
  30: { min: 1, max: 1 },
  31: { min: 1, max: 1 },
  32: { min: 1, max: 2 },
  33: { min: 1, max: 1 },
  34: { min: 1, max: 1 },
  35: { min: 1, max: 1 },
  36: { min: 1, max: 1 },
  37: { min: 1, max: 1 },
  38: { min: 1, max: 1 },
};

export function reportAutoFillResponseToAnnuncement({
  response,
  fileName,
  file,
  type,
  size,
}) {
  const {
    title,
    cities,
    regions,
    openingDate,
    reportingDate,
    beneficiary,
    types,
    promoting,
    granted,
    interventions,
    info,
    cumulation,
    detailImageInfo,
    cardImageFileName,
  } = response;
  const technicalPDF = {
    name: fileName,
    type: "application/pdf",
    base64: file,
    size,
  };
  return {
    title,
    openingDate:
      openingDate !== "" ? helper.dateToMilliseconds(openingDate) : undefined,
    reportingDate:
      reportingDate !== ""
        ? helper.dateToMilliseconds(reportingDate)
        : undefined, //Date.now(),
    ...getGeographicalInfoFromResponse({ cities, regions }),
    beneficiary: listToListOfName(beneficiary),
    types: listToListOfName(types),
    promoting,
    granted,
    technicalPDF,
    interventions,
    info,
    cumulation,
    correlatedAnnouncements: [],
    correlatedServices: [],
    detailImageInfo,
    cardImageFileName,
  };
}

function getGeographicalInfoFromResponse({ cities, regions }) {
  if (regions === "nazionale") {
    return {
      regions: listToListOfName(regioni),
      cities: listToListOfName(citta),
    };
  } else if (regions === "") {
    return {
      regions: [],
      cities: [],
    };
  } else {
    return {
      regions: [regions],
      cities,
    };
  }
}

export function getImageFileNameFromSectors({ sector, outgoings }) {
  let combinationIndex = 0;
  if (settori.length === sector.length) {
    if (outgoings.length >= 2) {
      combinationIndex = 1;
    } else if (outgoings.length === 1) {
      switch (outgoings[0]) {
        case "Attrezzature e macchinari":
          combinationIndex = 2;
          break;
        case "Avvio attività / StartUp":
          combinationIndex = 3;
          break;
        case "Consulenze/Servizi":
          combinationIndex = 4;
          break;
        case "Digitalizzazione":
          combinationIndex = 5;
          break;
        case "Formazione":
          combinationIndex = 6;
          break;
        case "Innovazione Ricerca e Sviluppo":
          combinationIndex = 7;
          break;
        case "Opere edili e impianti":
          combinationIndex = 8;
          break;
        case "Promozione/Export":
          combinationIndex = 9;
          break;
        case "Risparmio energetico/Fonti rinnovabili":
          combinationIndex = 10;
          break;
        default:
          break;
      }
    }
  } else {
    if (sector.length === 1 && outgoings.length >= 2) {
      switch (sector[0]) {
        case "Agricoltura":
          combinationIndex = 11;
          break;
        case "Artigianato":
          combinationIndex = 12;
          break;
        case "Commercio":
          combinationIndex = 13;
          break;
        case "Edilizia":
          combinationIndex = 14;
          break;
        case "Industria":
          combinationIndex = 15;
          break;
        case "Ristorazione":
          combinationIndex = 16;
          break;
        case "Servizi":
          combinationIndex = 17;
          break;
        case "Turismo e cultura":
          combinationIndex = 18;
          break;
        default:
          break;
      }
    } else if (
      sector.length === settori.length - 1 &&
      !sector.includes("Agricoltura")
    ) {
      if (outgoings.length >= 2) {
        combinationIndex = 19;
      } else if (outgoings.length === 1) {
        switch (outgoings[0]) {
          case "Attrezzature e macchinari":
            combinationIndex = 20;
            break;
          case "Avvio attività / StartUp":
            combinationIndex = 21;
            break;
          case "Consulenze/Servizi":
            combinationIndex = 22;
            break;
          case "Digitalizzazione":
            combinationIndex = 23;
            break;
          case "Formazione":
            combinationIndex = 24;
            break;
          case "Innovazione Ricerca e Sviluppo":
            combinationIndex = 25;
            break;
          case "Opere edili e impianti":
            combinationIndex = 26;
            break;
          case "Promozione/Export":
            combinationIndex = 27;
            break;
          case "Risparmio energetico/Fonti rinnovabili":
            combinationIndex = 28;
            break;
          default:
            break;
        }
      }
    } else if (
      sector.length === 2 &&
      sector.includes("Artigianato") &&
      sector.includes("Industria")
    ) {
      if (outgoings.length >= 2) {
        combinationIndex = 29;
      } else if (outgoings.length === 1) {
        switch (outgoings[0]) {
          case "Attrezzature e macchinari":
            combinationIndex = 30;
            break;
          case "Avvio attività / StartUp":
            combinationIndex = 31;
            break;
          case "Consulenze/Servizi":
            combinationIndex = 32;
            break;
          case "Digitalizzazione":
            combinationIndex = 33;
            break;
          case "Formazione":
            combinationIndex = 34;
            break;
          case "Innovazione Ricerca e Sviluppo":
            combinationIndex = 35;
            break;
          case "Opere edili e impianti":
            combinationIndex = 36;
            break;
          case "Promozione/Export":
            combinationIndex = 37;
            break;
          case "Risparmio energetico/Fonti rinnovabili":
            combinationIndex = 38;
            break;
          default:
            break;
        }
      }
    }
  }
  if (combinationIndex === 0) {
    return;
  }
  const imageIndex = getRandomIndex(
    IMAGE_COMBINATIONS[combinationIndex].max,
    IMAGE_COMBINATIONS[combinationIndex].min
  );
  const fileName = `${combinationIndex} Combinazione ${imageIndex}.jpg`;

  return fileName;
}

function getRandomIndex(max) {
  return Math.floor(Math.random() * max) + 1;
}

export function getStatus({ announcement }) {
  const { closingDate, openingDate, reportingDate } = announcement;
  if (closingDate && openingDate && reportingDate) {
    const now = Date.now();
    if (now >= closingDate) {
      return Status.CLOSED;
    } else if (now >= reportingDate && now < closingDate) {
      return Status.REPORTING;
    } else if (now >= openingDate && now < reportingDate) {
      return Status.OPEN;
    } else {
      return Status.ACTIVATING;
    }
  } else {
    return;
  }
}

export function getDataLabel(status) {
  switch (status) {
    case Status.ACTIVATING:
      return "Apre il";
    case Status.OPEN:
      return "Aperto fino al";
    case Status.REPORTING:
      return "Chiude il";
    case Status.CLOSED:
      return "Scaduto il";
    default:
      return "Data";
  }
}

export function getDate(status, item) {
  switch (status) {
    case Status.ACTIVATING:
      return helper.millisToDate({
        millis: item.openingDate,
      });
    case Status.OPEN:
      return helper.millisToDate({
        millis: item.reportingDate,
      });
    case Status.REPORTING:
      return helper.millisToDate({
        millis: item.closingDate,
      });
    case Status.CLOSED:
      return helper.millisToDate({
        millis: item.closingDate,
      });
    default:
      return PROPERTY_PLACEHOLDER;
  }
}

export function cropStringToFixedLength(text, length) {
  if (text.length > length) {
    return text.substring(FIRST_CHARACTER, length);
  } else {
    return text;
  }
}

export function getGeographicalArea(cities, regions) {
  if (cities.length === citta.length) {
    return "Nazionale";
  } else {
    let regionStatus = [];
    regions.forEach((region) => {
      regionStatus.push({
        name: region,
        cities: fileToList(regionsFile[`${region}`]),
        complete: false,
      });
    });
    cities.forEach((city) => {
      getRegionStatusFromCity(city, regionStatus).cities.find(
        ({ name }) => name === city
      ).covered = true;

      const isRegionStatusNotComplete = getRegionStatusFromCity(
        city,
        regionStatus
      ).cities.find(({ covered }) => covered === false);
      if (!isRegionStatusNotComplete) {
        getRegionStatusFromCity(city, regionStatus).complete = true;
      }
    });
    let value = "";
    regionStatus.forEach(({ name, complete, cities }) => {
      if (value.length > 0) {
        value = value + ", ";
      }
      if (complete) {
        value = value + name;
      } else {
        value = value + citiesStatusToList(cities);
      }
    });
    return value;
  }
  //const listOfCities = regionsFile[`${region}`];
}

function getRegionStatusFromCity(city, regionStatus) {
  return regionStatus.find(({ cities }) =>
    cities.find(({ name }) => name === city)
  );
}

function citiesStatusToList(list) {
  var value = "";
  list?.forEach(({ name, covered }) => {
    if (covered) {
      if (value.length) {
        value = value + ", ";
      }
      value = value + name;
    }
  });
  return value;
}

function fileToList(list) {
  return list?.map(({ name }) => {
    return { name, covered: false };
  });
}

export function listToString(list) {
  var value = "";
  list?.forEach((obj) => {
    if (value.length) {
      value = value + ", ";
    }
    value = value + obj;
  });
  return value;
}

export function setAllChoicesToValue(list, isChecked) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected: isChecked,
    };
  });
}

export function listToListOfName(list) {
  if (!list) return [];
  return list.map(({ name }) => name);
}

export function chekOffer(announcements, selectedAnnouncements) {
  return announcements?.map((announcement) => {
    return {
      ...announcement,
      isInOffer: contains(selectedAnnouncements, announcement.id),
    };
  });
}

export function contains(list, element) {
  return list?.indexOf(element) > -1;
}

export function isAnnouncementSelectable(offer, announcement) {
  let isSelectable = true;
  if (offer.correlatedServices.length) {
    offer.correlatedServices.forEach((serviceId) => {
      if (!announcement.correlatedServices.find((id) => serviceId === id)) {
        isSelectable = false;
      }
    });
  }

  if (offer.correlatedAnnouncements.length) {
    offer.correlatedAnnouncements.forEach((announcementId) => {
      if (
        !announcement.correlatedAnnouncements.find(
          (id) => announcementId === id
        )
      ) {
        isSelectable = false;
      }
    });
  }
  return isSelectable;
}
